<app-navbar></app-navbar>

<section class="error-404-area upper-margin">
    <div class="d-table">
        <div class="d-table-cell">
            <!-- data-aos="fade-up" data-aos-delay="100"-->
            <div class="container">

                <div class="notfound" *ngIf="IsSuccess">
                    <!-- data-aos="fade-up" data-aos-delay="100"-->
                    <h3 style="color:forestgreen">{{'Payment_Process_is_Successfully_Done' | translate }}</h3>
                    <!--data-aos="fade-up" data-aos-delay="100"-->
                    <p>{{'PaymentSuccessTXT' | translate }} {{thisID}}</p>
                    <!-- data-aos="fade-up" data-aos-delay="100"-->
                    <a routerLink="/" class="default-btn"> {{'Back_to_Homepage' | translate }}</a>
                </div>

                <div class="notfound" *ngIf="!IsSuccess">
                    <!-- data-aos="fade-up" data-aos-delay="100"-->
                    <h3 style="color:darkred">{{'Payment_Process_is_Failed' | translate }}</h3>
                    <!-- data-aos="fade-up" data-aos-delay="100"-->
                    <p>{{'PaymentFailedTXT' | translate }}</p>
                    <!-- data-aos="fade-up" data-aos-delay="100"-->
                    <a routerLink="/" class="default-btn"> {{'Back_to_Homepage' | translate }}</a>
                </div>

            </div>
        </div>
            </div>
</section>
